type LogEventFn = (eventName: string, metadata?: Record<string, unknown>) => void;
declare global {
  interface Window {
    __ca: (eventName: string, metadata?: Record<string, any>) => void;
    APP_SETTINGS: {
      collect_analytics: boolean;
      [key: string]: any;
    };
  }
}

const logEvent = (eventName: string, metadata: Record<string, any> = {}) => {
  if (!window.APP_SETTINGS?.collect_analytics) return;

  const payload = {
    ...metadata,
    event: eventName,
    url: window.location.href,
  };

  window.requestIdleCallback(() => {
    const params = new URLSearchParams({ __: JSON.stringify(payload) });
    const url = `/__ca/?${params}`;

    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url);
      } else {
        const img = new Image();

        img.src = url;
      }
    } catch {
      // Ignore errors here
    }
  });
};

if (!window.__ca) {
  window.__ca = logEvent;
}

/**
 * Log an event to the analytics system.
 *
 * Usage:
 * ```ts
 *  import { __ca } from './analytics';
 *
 *  __ca('event_name', { metadata: 'value' });
 * ```
 */
export const __ca = logEvent;

// Usage examples:
// __ca("data_import.view");
// __ca("template.select", { template_type: "object_detection", template_id: "od_1" });
// __ca("doc.click", { href: "https://cynaps.io/docs/guide/setup" });
